import { render, staticRenderFns } from "./ScorecardVendorSummary.vue?vue&type=template&id=5c195582"
import script from "./ScorecardVendorSummary.vue?vue&type=script&lang=js"
export * from "./ScorecardVendorSummary.vue?vue&type=script&lang=js"
import style0 from "./ScorecardVendorSummary.vue?vue&type=style&index=0&id=5c195582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports